'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './payment-plan-list.routes';

export class PaymentPlanListComponent {
  constructor(RecurringPaymentsService, Auth, dialogs) {
    'ngInject';
    this.dialogs = dialogs;
    this.RecurringPaymentsService = RecurringPaymentsService;

    this.frequencyMap = {
      "1m": "Every Month",
      "2m": "Every Two Months",
      "3m": "Every Three Months",
      "6m": "Every Six Months",
      "1y": "Every Year"
    };

    Auth.getCurrentUser(user => {
      RecurringPaymentsService.getByUser({id: user._id}, data => {
        this.data = data;
      });
    })
  }

  getNextPlannedPayment(startDate, frequency) {
    let addMap = {
      "1m": "1",
      "2m": "2",
      "3m": "3",
      "6m": "6",
      "1y": "12"
    };

    return moment(startDate).add(addMap[frequency], "months").toDate();
  }

  delete(recurringPayment) {
    var that = this;

    var recurringPaymentText = "<br/><br/><b>" + recurringPayment.subject + "</b><br/><p>$" + recurringPayment.amount + "</p>";

    var dlg = this.dialogs.confirm("Delete Recurring Payment Plan?", "Do you really want to delete this recurring payment?" + recurringPaymentText);
    dlg.result.then(() => {
      // OK delete it
      that.RecurringPaymentsService.delete({id: recurringPayment._id},
        () => {
          that.data = that.data.filter(function( obj ) {
            return obj._id !== recurringPayment._id;
          });

          //that.data = that.data.filter(obj => obj._id !== doc._id);
        },
        err => {
          alert("Could not delete recurring payment");
        });
    }, () => {
      // Cancel
    });
  }
}

export default angular.module('conduuApp.paymentPlanList', [uiRouter])
  .config(routes)
  .component('paymentPlanList', {
    template: require('./payment-plan-list.html'),
    controller: PaymentPlanListComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/payment/plan-list/payment-plan-list.component.js